import React, { createContext, useReducer, ReactNode, useEffect } from "react";
interface ApplicationState {
  selectedOrganization: number | null;
  selectedOrganizationData: any;
  selectedPhysicianData: any;
  selectedPathlabData: any;
  selectedPhysician: number | null;
  selectedPathLab: number | null;
  notificationCount: number;
  syncSuccess: boolean;
  approvalsCount: any;
  showInfoSlider: boolean;
  infoQuery: string;
}

const initialState: ApplicationState = {
  selectedOrganization: null,
  selectedOrganizationData: null,
  selectedPathlabData: null,
  selectedPhysician: null,
  selectedPhysicianData: null,
  selectedPathLab: null,
  notificationCount: 0,
  syncSuccess: false,
  approvalsCount: 0,
  showInfoSlider: false,
  infoQuery: "",
};

type ApplicationAction =
  | { type: "SET_ORGANIZATION"; payload: any }
  | { type: "SET_ORGANIZATION_DATA"; payload: any }
  | { type: "SET_PATHLAB_DATA"; payload: any }
  | { type: "SET_PHYSICIAN_DATA"; payload: any }
  | { type: "SET_PHYSICIAN"; payload: any }
  | { type: "SET_PATHLAB"; payload: any }
  | { type: "INITIALIZE_STATE"; payload: ApplicationState }
  | { type: "RESET" }
  | { type: "SET_NOTIFICATION_COUNT"; payload: number }
  | { type: "RESET_NOTIFICATION_COUNT" }
  | { type: "SET_SYNC_STATE"; payload: boolean }
  | { type: "SET_APPROVALS_COUNT"; payload: any }
  | {
      type: "SHOW_INFO_SLIDER";
      payload: { infoQuery: string };
    }
  | { type: "HIDE_INFO_SLIDER"; payload: any };

export const ApplicationState = createContext<{
  state: ApplicationState;
  dispatch: React.Dispatch<ApplicationAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const applicationReducer = (
  state: ApplicationState,
  action: ApplicationAction
): ApplicationState => {
  switch (action.type) {
    case "SET_ORGANIZATION": {
      const value = { ...state, selectedOrganization: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SHOW_INFO_SLIDER": {
      const value = {
        ...state,
        showInfoSlider: true,
        infoQuery: action.payload.infoQuery,
      };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "HIDE_INFO_SLIDER": {
      const value = {
        ...state,
        showInfoSlider: false,
        infoQuery: "",
      };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_SYNC_STATE": {
      const value = { ...state, syncSuccess: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_ORGANIZATION_DATA": {
      const value = { ...state, selectedOrganizationData: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_PATHLAB_DATA": {
      const value = { ...state, selectedPathlabData: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_PHYSICIAN_DATA": {
      const value = { ...state, selectedPhysicianData: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_PHYSICIAN": {
      const value = { ...state, selectedPhysician: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_PATHLAB": {
      const value = { ...state, selectedPathLab: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "INITIALIZE_STATE": {
      const appState = { ...state, ...action.payload };
      return appState;
    }
    case "RESET": {
      const appState = initialState;
      localStorage.setItem("applicationState", JSON.stringify(appState));
      return appState;
    }
    case "RESET_NOTIFICATION_COUNT": {
      const value = { ...state, notificationCount: 0 };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_NOTIFICATION_COUNT": {
      const value = { ...state, notificationCount: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    case "SET_APPROVALS_COUNT": {
      const value = { ...state, approvalsCount: action.payload };
      localStorage.setItem("applicationState", JSON.stringify(value));
      return value;
    }
    default:
      return state;
  }
};

interface ApplicationProviderProps {
  children: ReactNode;
}

export const ApplicationProvider: React.FC<ApplicationProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(applicationReducer, initialState);
  useEffect(() => {
    const storageData = localStorage.getItem("applicationState");
    if (storageData) {
      dispatch({ type: "INITIALIZE_STATE", payload: JSON.parse(storageData) });
    }
  }, []);

  return (
    <ApplicationState.Provider value={{ state, dispatch }}>
      {children}
    </ApplicationState.Provider>
  );
};

export default ApplicationState;
